// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/css/MaterialIcons.css
// module id = 300
// module chunks = 0